<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>
<section id="divIni" class="p-fluid pt-0 p-2">
    <button pButton label="Impórtar la totalidad de productos" (click)="beginProcessN()"></button>
    <div>
        <div class="p-inputgroup">
            <div class="p-inputgroup-addon">
                <i class="pi pi-bookmark"></i>
            </div>
            <input pInputText placeholder="Digite el código de producto" [(ngModel)]="productID" />
            <div class="p-inputgroup-addon">
                <button pButton label="Procesar único"(click)="querySKU(productID)" ></button>
            </div>
        </div>
    </div>
</section>
<p-dialog header="PROCESO DE CARGUE" [(visible)]="displayLoading" [modal]="true">
    <section>
        <div>Importando item nro. {{contador}} de {{listProducts.length}}</div>
        <div>
            <p-progressBar [value]="numProgress" />
        </div>
        <div>Importación con error: {{contadorError}} items</div>
        <div class="card overflow-auto" style="height:300px">
            <div class="items" *ngFor="let item of lsProductsErrors">Producto: {{item}}</div>
        </div>
    </section>
    <p-footer>

    </p-footer>
</p-dialog>
<p-toast></p-toast>